/* eslint @okta/okta/no-specific-modules: 0 */
import Handlebars from 'handlebars';
import markdownToHtml from '../markdownToHtml';

Handlebars.registerHelper('markdown', function (mdText) {
  return markdownToHtml(Handlebars, mdText);
});

export default Handlebars;



// WEBPACK FOOTER //
// /Users/aarongranick/okta/okta-ui/packages/courage/src/util/handlebars/helper-markdown.js


// WEBPACK FOOTER //
// webpack:///Users/aarongranick/okta/okta-ui/packages/courage/src/util/handlebars/helper-markdown.js